import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { adminApi } from "../auth";
import { AlertTriangle } from "lucide-react";

const AdminStock = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { adminApi.get("/stock").then((r) => setRows(r.data)).finally(() => setLoading(false)); }, []);

  return (
    <div data-testid="admin-stock-page">
      <h1 style={{ fontSize: 28 }}>Stock</h1>
      <p className="vd-muted mb-6">Track inventory across all products. Click a row to adjust stock.</p>
      <div className="vd-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left vd-muted uppercase text-xs tracking-wider border-b" style={{ borderColor: "var(--border-color)" }}>
            <th className="px-4 py-3">Product</th><th>Size</th><th>Stock Qty</th><th>Status</th><th className="text-right pr-4">Action</th>
          </tr></thead>
          <tbody>
            {loading ? <tr><td colSpan="5" className="px-4 py-8 text-center vd-muted">Loading…</td></tr> :
              rows.map((p) => (
                <tr key={p.id} className="border-t" style={{ borderColor: "var(--border-color)" }} data-testid={`stock-row-${p.id}`}>
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-3">
                      {p.image && <img src={p.image} alt="" className="w-10 h-10 rounded object-cover" style={{ background: "var(--bg-secondary)" }} />}
                      <span className="vd-heading font-medium">{p.brand} {p.model}</span>
                    </div>
                  </td>
                  <td className="vd-muted">{p.size}</td>
                  <td className="vd-heading font-bold" style={{ color: p.low_stock ? "var(--primary-red)" : "var(--text-heading)" }}>{p.stock_qty}</td>
                  <td>
                    {p.stock_qty === 0 ? (
                      <span className="text-xs font-semibold rounded px-2 py-0.5" style={{ background: "rgba(230,0,0,0.15)", color: "var(--primary-red)" }}>Out of stock</span>
                    ) : p.low_stock ? (
                      <span className="text-xs font-semibold inline-flex items-center gap-1 rounded px-2 py-0.5" style={{ background: "rgba(230,0,0,0.10)", color: "var(--primary-red)" }} data-testid={`stock-low-${p.id}`}><AlertTriangle size={12} /> Low stock</span>
                    ) : (
                      <span className="text-xs font-semibold rounded px-2 py-0.5" style={{ background: "rgba(0,180,80,0.15)", color: "#00A35C" }}>OK</span>
                    )}
                  </td>
                  <td className="pr-4 text-right">
                    <Link to={`/admin/stock/${p.id}`} className="text-sm font-semibold" style={{ color: "var(--primary-red)" }} data-testid={`stock-adjust-${p.id}`}>Adjust →</Link>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminStock;
